import { client } from "./client";

const ROUTES = {
  createMoveLines: () => `/create_move_lines/`,
};

export const accounts = {
  createMoveLines: ({ id }) => {
    return client.get(ROUTES.createMoveLines(), {
      params: {
        id
      }
    });
  },
};
